import React, { useState, useEffect } from "react";
import CardEl from "../Elements/CardEl";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import { engApi } from "../api/engApi";
import { useSelector } from "react-redux";
import Select from "react-select";
import { optionsBranch } from "../data/branch-data";

const StudentForm = () => {
  const { register, handleSubmit, reset, control, watch } = useForm();
  const profile = useSelector((state) => state.profileReducer.profile);
  // const getUsername = "55050419";
  const getUsername = localStorage.getItem("username");
  const [allStudent, setAllStudent] = useState([]);
  const [matchStudent, setMatchStudent] = useState({});
  const [st_id, setSt_id] = useState(0);

  const getAllStudent = async () => {
    try {
      const response = await engApi.get("/all-student/");

      setAllStudent(response.data);

      const std = response.data.find((st) => st.id === getUsername);

      reset({
        st_id: +std.id,
        b_id: std.b_id,
        gpa: std.gpa,
        st_name: std.name,
        status: std.status,
      });

      // setSt_id(+std.id);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (profile && profile.m_role === "student") {
      getAllStudent();
    }
  }, [profile]);

  const displayProfile = (
    <CardEl title="ข้อมูลส่วนตัว">
      <img
        src={`http://reg.buu.ac.th/registrar/getstudentimage.asp?id=${profile?.id}`}
        width="150px"
        className="my-4"
      />
      <div className="mb-3 row">
        <label className="col-form-label col-sm-2 text-sm-right">
          รหัสนิสิต
        </label>
        <div className="col-sm-10">
          <input
            type="number"
            // disabled
            readOnly
            className="form-control input-muted"
            placeholder="โปรดระบุ"
            // onChange={(ev) => setSt_id(+ev.target.value)}
            {...register("st_id", { required: true })}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label className="col-form-label col-sm-2 text-sm-right">ชื่อ</label>
        <div className="col-sm-10">
          <input
            type="text"
            // disabled
            readOnly
            className="form-control input-muted"
            placeholder="โปรดระบุ"
            {...register("st_name", { required: true })}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label className="col-form-label col-sm-2 text-sm-right">
          Email ที่ติดต่อได้ <span className="text-danger">*</span>
        </label>
        <div className="col-sm-10">
          <input
            type="email"
            className="form-control"
            placeholder="โปรดระบุ"
            {...register("st_mail", { required: true })}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label className="col-form-label col-sm-2 text-sm-right">
          เบอร์โทร <span className="text-danger">*</span>
        </label>
        <div className="col-sm-10">
          <input
            type="text"
            className="form-control"
            placeholder="โปรดระบุ"
            {...register("st_tel", { required: true })}
          />
        </div>
      </div>

      <div className="mb-3 row">
        <label className="col-form-label col-sm-2 text-sm-right">ภาควิชา</label>

        <div className="col-sm-10">
          <input
            type="number"
            className="form-control d-none"
            readOnly
            placeholder="โปรดระบุ"
            {...register("b_id", {
              required: true,
            })}
          />
          <input
            type="text"
            className="form-control input-muted"
            readOnly
            placeholder="โปรดระบุ"
            value={
              optionsBranch.length
                ? optionsBranch.find((el) => el.value == watch("b_id"))?.label
                : 0
            }
          />
          {/* <select
            className="form-select"
            {...register("b_id", { required: true })}
            // disabled
          >
            <option selected>กรุณาเลือก</option>
            {optionsBranch.length ? (
              optionsBranch.map((item) => {
                return <option value={item.value}>{item.label}</option>;
              })
            ) : (
              <option selected>ไม่มีตัวเลือก</option>
            )}
          </select> */}
        </div>
      </div>

      <div className="mb-3 row">
        <label className="col-form-label col-sm-2 text-sm-right">
          ปีการศึกษา
        </label>
        <div className="col-sm-10">
          <input
            type="number"
            className="form-control"
            readOnly
            // disabled
            placeholder="โปรดระบุ"
            {...register("school_yrs", {
              required: true,
              value: new Date().getFullYear() + 543,
            })}
          />
        </div>
      </div>

      <div className="mb-3 row">
        <label className="col-form-label col-sm-2 text-sm-right">
          เกรดเฉลี่ยสะสม
        </label>
        <div className="col-sm-10">
          <input
            type="number"
            step={0.01}
            className="form-control"
            // disabled
            placeholder="โปรดระบุ"
            {...register("gpa", { required: true })}
          />
        </div>
      </div>

      <div className="mb-3 row">
        <label className="col-form-label col-sm-2 text-sm-right"></label>
        {/* <div className="col-sm-10">
          มีความประสงค์ขอฝึกงานในปีการศึกษา {new Date().getFullYear() + 543}
        </div> */}
      </div>
    </CardEl>
  );

  return (
    <div className="main">
      <main className="content">
        <div className="container-fluid p-0">
          <div className="h3 mb-3">ลงทะเบียนเข้าสู่ระบบ</div>
          <form action="./save-profile-student.php" method="post">
            {displayProfile}

            <button type="submit" className="btn btn-primary">
              ลงทะเบียน
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default StudentForm;
